import { Schema } from "effect";
export { developmentString as worktreeString, developmentInteger as worktreeInteger, DevelopmentBodyObject as WorktreeBodyObject, developmentBody as worktreeBody } from "../development/input.ts";

export const WORKTREE_BODY_BYTES = 1_100_000;
export const WORKTREE_BLOB_BYTES = 1_000_000;
export const WORKTREE_MUTATION_LIMIT = 256;
export const WorktreeMutationInput = /* @__PURE__ */ (() => Schema.Record(Schema.String, Schema.Json))();
// The HTTP shell checks only the envelope of each mutation before it looks up the
// worktree; the repository validates the twelve mutation variants and canonical paths.
export const WorktreeMutations = /* @__PURE__ */ (() => Schema.Array(Schema.Json).annotate({ message: "mutations must be a non-empty array." }).check(
  Schema.isMinLength(1, { message: "mutations must be a non-empty array." }),
  Schema.isMaxLength(WORKTREE_MUTATION_LIMIT, { message: "mutations exceeds 256 operations." }),
  Schema.makeFilter(values => {
    for (const [index, value] of values.entries()) {
      if (!Schema.is(Schema.Struct({ kind: Schema.String }))(value)) return `mutations[${index}] is invalid.`;
      if (value.kind === "file.write") {
        if (!Schema.is(Schema.Struct({ contents: Schema.String }))(value)) return `mutations[${index}].contents must be text.`;
        if (new TextEncoder().encode(value.contents).byteLength > WORKTREE_BLOB_BYTES) return `mutations[${index}].contents exceeds 1000000 bytes.`;
      }
    }
    return true;
  })
))();
export const WORKTREE_CREATE_FIELDS = ["worktreeId", "baseCommitId", "branchRef", "idempotencyKey"] as const;
export const WORKTREE_ACTION_FIELDS = {
  diff: ["targetTreeId", "targetCommitId"],
  lease: ["expectedVersion", "expectedFence", "attemptId", "expiresAt", "idempotencyKey"],
  patch: ["expectedVersion", "fence", "attemptId", "idempotencyKey", "mutations"],
  commit: ["expectedVersion", "fence", "attemptId", "idempotencyKey", "message"],
  cancel: ["expectedVersion", "fence", "attemptId", "reason", "idempotencyKey"],
  destroy: ["expectedVersion", "fence", "idempotencyKey"]
} as const;
export const WorktreeAction = /* @__PURE__ */ (() => Schema.Literals(["diff", "lease", "patch", "commit", "cancel", "destroy"]))();
